import { ApiInit } from '@/api/api'
import globalConfig from '@/config'

export default {
    data() {
        return {
            pollingSocketsGo: false
        }
    },
    created() {
        this.$root.$once('emitPollingSockets', this.pollingSockets)
    },
    beforeDestroy() {
        this.pollingSocketsGo = false
    },
    computed: {},
    methods: {
        pollingSocketsInit() {
            if (!this.pollingSocketsGo) return
            ApiInit.socketPolling({
                socketGroupId: this.$store.state.api.socketGroupId,
                type: 'guest'
            })
                .then(response => {
                    if (!response) return
                    response.data.forEach(itemApi => {
                        let socketStoreItemFind = this.$store.state.sockets.history.find(
                            itemStore => itemStore?.socket_id === itemApi.payload.socket_id
                        )
                        if (!socketStoreItemFind) {
                            let socketEmitName = this.$store.state.sockets.emitList[itemApi.event]
                            if (!itemApi.payload) {
                                return
                            }
                            itemApi.payload.isPolling = true
                            if (itemApi.event === 'message') itemApi.payload.isPolling = true //используем в storeChat.js

                            this.$root.$emit(socketEmitName, itemApi.payload)
                        }
                    })
                })
                .finally(() => {
                    let interval = globalConfig.polling_interval_ms
                        ? globalConfig.polling_interval_ms
                        : 5000
                    setTimeout(() => {
                        this.pollingSocketsInit()
                    }, interval)
                })
        },
        pollingSockets() {
            if (!globalConfig.polling_server) return
            this.pollingSocketsGo = true
            this.pollingSocketsInit()
            setTimeout(() => {
                this.$store.commit('sockets/historyClear')
            }, 60 * 1000)
        }
    }
}
